import { connect } from 'react-redux';
import { get } from 'lodash';
import View from './component';
import { setMessage } from './actions';

const mapStateToProps = (state) => ({
  message: get(state, 'screenBlocker.message'),
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(setMessage({ message: null })),
});

const ScreenBlocker = connect(mapStateToProps, mapDispatchToProps)(View);

export default ScreenBlocker;
